import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { LogLevelOption } from '../models/log-level-option.interface';

export const logLevelOptionActions = createEagerSelectActions<LogLevelOption>('[Log Level Options]');
